import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { AccordionItemModule } from "../accordion-item/accordion-item.module";
import { MobileDropdownComponent } from "./mobile-dropdown.component";

@NgModule({
    imports: [
        AccordionItemModule,
        CommonModule
    ],
    declarations: [MobileDropdownComponent],
    exports: [MobileDropdownComponent],
})

export class MobileDropdownModule { }